import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { PageIndices } from '../common/i-doc/i-doc.registry.ts';
import { expertInvitationsService } from '../services/expert-invitations.service';

const AcceptInvitePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') ?? '';

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Токен відсутній або некоректний.');
      return;
    }

    expertInvitationsService.acceptByToken(token)
      .then(res => {
        if (res.success) {
          setStatus('success');
        } else {
          setStatus('error');
          setMessage(res.message);
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Сталася помилка при активації акаунту. Спробуйте ще раз або зверніться до підтримки.');
      });
  }, [token]);

  return (
    <Box
      data-i-doc={PageIndices.ACCEPT_INVITE}
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Box sx={{ maxWidth: 440, width: '100%', textAlign: 'center' }}>
        {status === 'loading' && (
          <>
            <CircularProgress sx={{ mb: 3 }} />
            <Typography variant="h6" color="text.secondary">Активація акаунту...</Typography>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircleOutlineIcon sx={{ fontSize: 72, color: 'success.main', mb: 2 }} />
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Акаунт створено!
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              Для входу скористайтеся функцією «Забули пароль» — вам надійде лист із посиланням для встановлення пароля.
            </Typography>
            <Button variant="contained" size="large" onClick={() => navigate('/auth')}>
              Перейти до входу
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <ErrorOutlineIcon sx={{ fontSize: 72, color: 'error.main', mb: 2 }} />
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Посилання недійсне
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              {message || 'Посилання вже використане або прострочене.'}
            </Typography>
            <Button variant="outlined" onClick={() => navigate('/auth')}>
              Перейти до входу
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default AcceptInvitePage;
